import { Size } from "../../../domain/drawing/Size";

export class TrimmingResult {
  size: Size;
  imageDataText: string;
}
